/**
 * tradeAlertSlice — global trade signal popup state.
 *
 * UI-only state for the trade intelligence popup. Separated from market data
 * so popup show/hide doesn't interact with data subscriptions.
 */
import type { StateCreator } from 'zustand'
import type { MarketStore, TradeAlertState } from './types'

export const createTradeAlertSlice: StateCreator<MarketStore, [], [], TradeAlertState> = (set) => ({
    activeTradeAlert: null,
    isTradeAlertVisible: false,
    isTradeAlertMinimized: typeof window !== 'undefined' ? localStorage.getItem('tradeIntelMinimized') === 'true' : false,

    setActiveTradeAlert: (alert) => set({ activeTradeAlert: alert }),
    setTradeAlertVisible: (visible) => set({ isTradeAlertVisible: visible }),
    setTradeAlertMinimized: (minimized) => {
        if (typeof window !== 'undefined') localStorage.setItem('tradeIntelMinimized', String(minimized))
        set({ isTradeAlertMinimized: minimized })
    },
})
